<template>
  <PageLoading :loading="loading">
    <!-- 错误页面 -->
    <ErrorPage v-if="hasError" :title="errorTitle" :message="errorMessage" />

    <!-- 正常页面 -->
    <div v-else class="completed-cards-page">
      <!-- 顶部标题 -->
      <div class="page-header">
        <span class="total-cards">共{{ completedCards.length }}张</span>
      </div>

      <!-- 已完成卡片列表 -->
      <!-- 空状态 -->
      <div v-if="completedCards.length === 0" class="empty-state">
        <van-empty description="暂无已完成卡片" />
      </div>
      <!-- 卡片列表 -->
      <div v-else>
        <div class="cards-container">
          <div class="card-item" v-for="card in completedCards" :key="card.id" @click="viewCardDetail(card)">
            <!-- 卡片上半部分 - 剩余瓶数 -->
            <div class="card-top">
              <div class="bottles-info" v-if="card.card_type == '瓶数卡'">
                <span class="bottles-label">剩余瓶数:</span>
                <span class="bottles-count">{{ card.surplus_number }}</span>
              </div>
              <div class="bottles-info" v-if="card.card_type == '金额卡'">
                <span class="bottles-label">剩余金额:</span>
                <span class="bottles-count">¥{{ card.card_balance }}</span>
              </div>
            </div>

            <!-- 卡片下半部分 - 卡号和绑定时间 -->
            <div class="card-bottom">
              <div class="card-info">
                <span class="card-number">卡号: {{ card.card_no }}</span>
                <span class="bind-time">绑定时间: {{ card.bind_date }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </PageLoading>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { setWxTitle } from '@/utils/wx'
import { post } from '@/utils/request'

// 加载状态
const loading = ref(true)

// 错误状态
const hasError = ref(false)
const errorTitle = ref('')
const errorMessage = ref('')

// 已完成卡片数据
const completedCards = ref([])

// 处理错误
const handleError = (title, message) => {
  hasError.value = true
  errorTitle.value = title
  errorMessage.value = message
  loading.value = false
}

onMounted(() => {
  setWxTitle('已完成的卡片')
  initPage()
})

// 页面初始化
const initPage = async () => {
  try {
    // 调用接口获取已完成卡片信息
    const res = await post('/api/select/community/card/info', {
      partner_id: parseInt(localStorage.getItem('userId')),
      company_ids: JSON.parse(localStorage.getItem('company_ids')),
      state: '已完成',
    })
    if (res.result && res.result.state === 'ok') {
      completedCards.value = res.result.card_info_arr || []
    } else {
      handleError('加载失败', res.result?.message || '接口异常')
    }
  } catch (error) {
    console.error('页面初始化失败:', error)
    handleError('加载失败', '页面加载失败，请重试')
  } finally {
    loading.value = false
  }
}

// 查看卡片详情
const viewCardDetail = (card) => {
  console.log('查看卡片详情:', card)
  // 可以跳转到卡片详情页面
  window.location.href = `/card-detail?card_id=${card.card_id}`
}
</script>

<style scoped>
.completed-cards-page {
  min-height: calc(100vh - 32px);
  background: #fff;
  padding: 16px;
}

.page-header {
  margin-bottom: 20px;
}

.total-cards {
  font-size: 16px;
  color: #333;
  font-weight: 500;
}

.cards-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.card-item {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.2s ease;
}

.card-item:hover {
  transform: translateY(-2px);
}

.card-item:active {
  transform: translateY(0);
}

.card-top {
  background: linear-gradient(135deg, #8b8b8b, #a0a0a0);
  padding: 20px 16px;
  color: #fff;
}

.bottles-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.bottles-label {
  font-size: 14px;
  opacity: 0.9;
}

.bottles-count {
  font-size: 32px;
  font-weight: 600;
  color: #fff;
}

.card-bottom {
  background: linear-gradient(135deg, #666666, #7a7a7a);
  padding: 16px;
  color: #fff;
}

.card-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}

.card-number,
.bind-time {
  opacity: 0.9;
}

.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
}
</style>